<template lang="pug">
  multiselect(
    v-model="selectedCities"
    :options="cities"
    label="label"
    track-by="value"
    :show-labels="false"
    placeholder="Localisation"
    :searchable="false"
    :close-on-select="false"
    :multiple="true"
    :taggable="$mq === 'desktop'"
    class="multiselect--check multiselect--all multiselect--localisation"
  )
    template(
      slot="selection"
      slot-scope="{ values, search, isOpen }"
      v-if="$mq === 'mobile'"
    )
      span.multiselect__single(class="flex items-center" v-if="values.length || isOpen")
        span(class="align-middle text-14") Localisation
        mark(class="inline-flex items-center justify-center ml-2" v-if="values.length") {{ values.length }}

    template(slot="beforeList")
      div(class="p-5") Dans quelle ville ?

    template(slot="afterList")
      span(class="multiselect__option multiselect__all" :class="{'multiselect__option--selected': isComplete}" @click="toggleSelect") {{ toggleSelectSentence }}

</template>

<script>
export default {
  props: {
    initialCities: {
      type: Array,
      default: () => {
        return []
      }
    },

    cities: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      selectedCities: []
    }
  },

  computed: {
    isComplete () {
      return this.selectedCities.length === this.cities.length
    },

    toggleSelectSentence () {
      return this.isComplete ? 'Tout déselectionner' : 'Tout sélectionner'
    }
  },

  watch: {
    selectedCities () {
      this.$store.commit('updateParams', { key: 'by_cities', value: this.selectedCities.map(city => city.value) })

      this.$store.dispatch('searchAccommodations')
    }
  },

  mounted () {
    this.selectedCities = [...this.cities.filter(city => this.initialCities.includes(city.value.toString()))]

    this.$nextTick(() => {
      this.$store.commit('updateReady', 'locationSelect')
    })
  },

  methods: {
    toggleSelect () {
      if (this.isComplete) {
        this.selectedCities = []
      } else {
        this.selectedCities = [...this.cities]
      }
    }
  }
}
</script>
